import { render, staticRenderFns } from "./AIAssistanceButton.vue?vue&type=template&id=27b95eaa&scoped=true&"
import script from "./AIAssistanceButton.vue?vue&type=script&lang=js&"
export * from "./AIAssistanceButton.vue?vue&type=script&lang=js&"
import style0 from "./AIAssistanceButton.vue?vue&type=style&index=0&id=27b95eaa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27b95eaa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('27b95eaa')) {
      api.createRecord('27b95eaa', component.options)
    } else {
      api.reload('27b95eaa', component.options)
    }
    module.hot.accept("./AIAssistanceButton.vue?vue&type=template&id=27b95eaa&scoped=true&", function () {
      api.rerender('27b95eaa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/components/widgets/AIAssistanceButton.vue"
export default component.exports